export default __webpack_public_path__ + "static/media/notification.99810f37.mp3";